import { ConditionalRuleKind, ConditionalRule } from './types';

export default () =>
  Object.entries(ConditionalRuleKind).map(([key, val]) => {
    return {
      kind: key,
      value: val
    } as ConditionalRule;
  });

export const conditionalRuleDictionary: Record<
  ConditionalRuleKind,
  {
    validate: (value: number, val1: number, val2: number) => boolean;
  }
> = {
  [ConditionalRuleKind.EQUALS]: {
    validate: (value: number, val1: number) => value === val1
  },
  [ConditionalRuleKind.IS_LESS_THAN]: {
    validate: (value: number, val1: number) => value < val1
  },
  [ConditionalRuleKind.IS_GREATER_THAN]: {
    validate: (value: number, val1: number) => value > val1
  },
  [ConditionalRuleKind.IS_BETWEEN]: {
    validate: (value: number, val1: number, val2: number) =>
      value >= val1 && value <= val2
  },
  [ConditionalRuleKind.IS_NOT_BETWEEN]: {
    validate: (value: number, val1: number, val2: number) =>
      value < val1 || value > val2
  }
};
